import { SubmitDraftReturnResultSchema } from "@redotech/redo-return-core-common/draft-return/submit-draft-return";
import { ChannelZod } from "@redotech/redo-return-core-common/return";
import { SettlementSchema } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const submitDraftReturn = {
  name: "submitDraftReturn" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    isRejected: z.boolean().nullish(),
    settlement: SettlementSchema.nullish(),
    paymentToken: z.string().nullish(),
    channel: ChannelZod.optional(),
  }),
  output: SubmitDraftReturnResultSchema,
};
